export default __webpack_public_path__ + "static/media/app-release.2d805d6b.apk";